module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('mu-appbar', [_c('span', {
    staticClass: "topT"
  }, [_vm._v("会员卡兑换")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "bigpage"
  }, [_c('div', {
    attrs: {
      "align": "left"
    }
  }, [_c('mu-text-field', {
    staticStyle: {
      "margin-left": "-4%",
      "width": "103%"
    },
    attrs: {
      "hintText": "请输入手机号",
      "type": "text",
      "icon": "smartphone"
    },
    model: {
      value: (_vm.UserPhone),
      callback: function($$v) {
        _vm.UserPhone = $$v
      },
      expression: "UserPhone"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    staticStyle: {
      "margin-left": "-4%",
      "width": "103%"
    },
    attrs: {
      "hintText": "请输入真实姓名",
      "type": "text",
      "icon": "person "
    },
    model: {
      value: (_vm.RealName),
      callback: function($$v) {
        _vm.RealName = $$v
      },
      expression: "RealName"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    staticStyle: {
      "margin-left": "-4%",
      "width": "103%"
    },
    attrs: {
      "hintText": "请输入邮箱(选填)",
      "type": "text",
      "icon": "email "
    },
    model: {
      value: (_vm.UserEmail),
      callback: function($$v) {
        _vm.UserEmail = $$v
      },
      expression: "UserEmail"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    staticStyle: {
      "margin-left": "-4%",
      "width": "103%"
    },
    attrs: {
      "hintText": "请设置您的密码",
      "type": "password",
      "icon": "lock"
    },
    model: {
      value: (_vm.UserPass),
      callback: function($$v) {
        _vm.UserPass = $$v
      },
      expression: "UserPass"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    staticStyle: {
      "margin-left": "-4%",
      "width": "103%"
    },
    attrs: {
      "hintText": "请输入8位兑换码",
      "type": "text",
      "icon": "verified_user"
    },
    model: {
      value: (_vm.CardCode),
      callback: function($$v) {
        _vm.CardCode = $$v
      },
      expression: "CardCode"
    }
  }), _vm._v(" "), _c('nobr', [_c('mu-text-field', {
    staticClass: "txtValidate",
    staticStyle: {
      "margin-left": "-4%",
      "width": "72%"
    },
    attrs: {
      "hintText": "请输入附加码",
      "type": "text",
      "icon": "vpn_key"
    },
    model: {
      value: (_vm.FJM),
      callback: function($$v) {
        _vm.FJM = $$v
      },
      expression: "FJM"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "27%",
      "margin-left": "2%",
      "margin-bottom": "-2%"
    },
    attrs: {
      "src": this.TPFJM
    },
    on: {
      "click": this.getValidateCode
    }
  })], 1)], 1), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "font-size": "0.3rem",
      "margin-top": "0.5rem"
    },
    style: ({
      width: '100%',
      height: '0.8rem'
    }),
    attrs: {
      "label": "兑 换",
      "primary": ""
    },
    on: {
      "click": _vm.cardExchange
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": this.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "dialogClass": "dialog-cardno",
      "title": _vm.dialogTitle,
      "open": _vm.showDialog
    }
  }, [_c('mu-flexbox', {
    attrs: {
      "orient": "vertical"
    }
  }, [_c('mu-flexbox-item', [_c('mu-card-text', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "700",
      "text-align": "center"
    }
  }, [_vm._v("会员卡兑换成功！")])], 1), _vm._v(" "), _c('mu-flexbox-item', [_c('mu-card-text', [_vm._v("卡号：" + _vm._s(_vm.CardNo))])], 1), _vm._v(" "), _c('mu-flexbox-item', [_c('mu-card-text', [_vm._v("类型：" + _vm._s(_vm.CardKind))])], 1), _vm._v(" "), _c('mu-flexbox-item', [_c('mu-raised-button', {
    staticStyle: {
      "font-size": "0.3rem",
      "margin-top": "0.5rem"
    },
    style: ({
      width: '100%',
      height: '0.8rem'
    }),
    attrs: {
      "label": "我知道了",
      "primary": ""
    },
    on: {
      "click": _vm.goLogin
    }
  })], 1), _vm._v(" "), _c('mu-flexbox-item', [_c('mu-card-text', [_vm._v(_vm._s(_vm.NewInfo))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75633737!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/NonVerified/CreateCard.vue
// module id = 1547
// module chunks = 18